import { isNumeric } from '../../util/helpers';

import {LatLon} from '../../util/geodesy/latlon';
import {parseLatLon} from '../util/parseUtils';

/**
 * Local attractions for airport
 */
export class LocalAttraction {
  /**
   * Unique identifier for this record in the database
   */
  id: number;

  /**
   * Airport record ID for which this record applies
   */
  airportId: number;

  /**
   * Source ID that identifies the source of this data (e.g., airport manager)
   */
  sourceId: number;

  /**
   * The type/category for this travel record (e.g., Transportation)
   */
  travelType: string;

  /**
   * The subtype/subcategory for this travel record (e.g., Taxi)
   */
  travelRef: string;

  /**
   * Date this record was created
   */
  createDate: Date;

  /**
   * Date this record will expire
   */
  expirationDate: Date;

  /**
   * Telephone number of attraction
   */
  phone: string;

  /**
   * URL of attraction
   */
  website: string;

  /**
   * The distance in miles of the attraction from the associated airport
   */
  distance: number;

  /**
   * Name of the attraction
   */
  name: string;

  /**
   * Indicates whether this attraction is valid
   */
  validityFlag: string;

  /**
   * Last update date for this record
   */
  updateDate: Date;

  /**
   * User ID who last modified this record
   */
  updateBy: string;

  /**
   * Address of attraction
   */
  address: string;

  /**
   * Street address 1 of attraction
   */
  street1: string;

  /**
   * City of attraction
   */
  city: string;

  /**
   * State abbreviation for US and Canada of attraction
   */
  state: string;

  /**
   * Zip code of attraction
   */
  zip: string;

  /**
   * Country abbreviation of attraction
   */
  country: string;

  /**
   * Local attraction latitude and longitude
   */
  location: LatLon;

  /**
   * Google Place ID of attraction
   */
  placeId: string;

  /**
   * Parses noise abatement data
   * @param data {any} Noise abatement data as returned by API
   * @return {NoiseAbatement} Parsed nosie abatement data
   */
  static parse(data: any): LocalAttraction {
    return {
      id: data.travelId,
      airportId: data.airportId,
      sourceId: data.sourceId,
      travelType: data.travelType || null,
      travelRef: data.travelRef || null,
      createDate: data.createDate ? new Date(data.createDate) : null,
      expirationDate: data.expirationDate ? new Date(data.expirationDate) : null,
      phone: data.phone || null,
      website: data.website || null,
      distance: isNumeric(data.distance) ? +data.distance : null,
      name: data.name || null,
      validityFlag: data.validityFlag || null,
      updateDate: data.updateDate ? new Date(data.updateDate) : null,
      updateBy: data.updateBy || null,
      address: data.address || null,
      street1: data.street1 || null,
      city: data.city || null,
      state: data.state || null,
      zip: data.zip || null,
      country: data.country || null,
      location: data.location ? parseLatLon(data.location.latitude, data.location.longitude) : null,
      placeId: data.placeId || null
    };
  }
}
